(function () {
  'use strict';

  // Animation timings (Figma spec — mirrors announcement-bar.js)
  const CYCLE_DELAY = 6000;
  const DURATION = 600;
  const EASING = 'cubic-bezier(0.42, 0, 0.58, 1)'; // ease-both

  const HAS_WAAPI =
    typeof Element !== 'undefined' && typeof Element.prototype.animate === 'function';
  const prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setState(el, opacity, translateY) {
    el.style.opacity = String(opacity);
    el.style.transform = 'translateY(' + translateY + ')';
  }

  function slide(el, fromOpacity, fromY, toOpacity, toY) {
    const anim = el.animate(
      [
        { opacity: fromOpacity, transform: 'translateY(' + fromY + ')' },
        { opacity: toOpacity, transform: 'translateY(' + toY + ')' },
      ],
      { duration: DURATION, easing: EASING, fill: 'forwards' }
    );
    anim.addEventListener('finish', function () {
      try {
        anim.commitStyles();
        anim.cancel();
      } catch (_) {
        setState(el, toOpacity, toY);
      }
    });
  }

  function initBanner(root) {
    if (root.hasAttribute('data-usp-banner-init')) return;
    root.setAttribute('data-usp-banner-init', '');

    const messages = root.querySelectorAll('[data-usp-message]');
    if (messages.length < 2) return;
    if (!HAS_WAAPI || prefersReducedMotion) return;

    let activeIndex = 0;

    messages.forEach(function (msg, i) {
      setState(msg, i === 0 ? 1 : 0, '0');
    });

    function cycle() {
      const current = messages[activeIndex];
      const nextIndex = (activeIndex + 1) % messages.length;
      const next = messages[nextIndex];

      setState(next, 0, '100%');
      next.removeAttribute('aria-hidden');
      current.setAttribute('aria-hidden', 'true');

      slide(current, 1, '0', 0, '-100%');
      slide(next, 0, '100%', 1, '0');

      activeIndex = nextIndex;
    }

    setInterval(cycle, CYCLE_DELAY);
  }

  function init() {
    // Global query is intentional: the snippet renders in multiple contexts (PDP, announcement-bar).
    // Loaded as type="module" so the browser deduplicates — matches the input.js pattern.
    document.querySelectorAll('[data-usp-banner]').forEach(initBanner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
